import React from "react";
import { BoltIcon } from "@heroicons/react/16/solid";
import { CheckIcon, StarIcon } from "@heroicons/react/16/solid";

const checklist = [
	"Personeelsregelement in een handomdraai",
	"Onbeperkt contracten maken",
	"Overeenkomsten van opdracht",
];

const PromoPiece = ({ trialDays }) => {
	return (
		<div className="">
			<div className="flex items-center mb-4">
				{/* <div className="bg-gradient-to-r from-purple-600 to-indigo-600 p-2 rounded-full ">
			<SparklesIcon className="size-6 text-white" />
		</div> */}
			</div>
			{trialDays !== 0 && (
				<span className="text-sm px-2.5 pr-3.5 py-1 bg-blue-100 gap-1.5 items-center flex rounded-full font-semibold w-fit text-blue-600 mb-2">
					<BoltIcon className="size-4 " />
					Direct toegang
				</span>
			)}
			<h1 className="text-2xl font-bold text-gray-900 mb-2 animate-slide-up">
			Maak je personeelsreglement en contracten in een handomdraai
			</h1>
			<p className=" text-gray-600 animate-slide-up">
			Ontwikkeld door een ervaren arbeidsjurist met 10+ jaar ervaring in de mondzorg.
			</p>

			<div className="mt-12 pb-6">
				<ul className="space-y-2 mb-6">
					{checklist.map((item, idx) => (
						<li key={idx} className="flex items-start gap-2">
							<CheckIcon className="size-5 text-green-600 mt-0.5 flex-shrink-0" />
							<span className="text-gray-800">{item}</span>
						</li>
					))}
				</ul>
			</div>
			<div className="pt-12 border-t border-gray-200">
				<div className="grid gap-10 md:grid-cols-2">
					<div>
						<div className="flex items-center gap-0.5 text-orange-500 mb-3">
							{Array.from({ length: 5 }).map((_, idx) => (
								<StarIcon key={idx} className="size-4 fill-orange-500 text-orange-500" />
							))}
						</div>
						<p className="text-gray-900 text-sm leading-relaxed mb-3">
							“Zo onhandig dat de KNMT tool er niet meer is, maar met DentHR is dit helemaal opgelost.”
						</p>
						<div className="flex items-baseline gap-2">
							<span className="font-semibold text-gray-900 text-xs">Paul D.</span>
							<span className="text-xs text-gray-500">Praktijkmanager</span>
						</div>
					</div>

					<div>
						<div className="flex items-center gap-0.5 text-orange-500 mb-3">
							{Array.from({ length: 5 }).map((_, idx) => (
								<StarIcon key={idx} className="size-4 fill-orange-500 text-orange-500" />
							))}
						</div>
						<p className="text-gray-900 text-sm leading-relaxed mb-3">
							“Heel gemakkelijk voor iemand met weinig kennis van zaken om een ingewikkeld document te maken”
						</p>
						<div className="flex items-baseline gap-2">
							<span className="font-semibold text-gray-900 text-xs">Marieke Z.</span>
							<span className="text-xs text-gray-500">Tandarts</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PromoPiece;
